
<template>
    <div class="center">
      <vs-dialog v-model="active" @close="borrar">
        <template #header>
          <h4 class="not-margin">
                Solicitar inscripcón en otro programa
          </h4>
        </template>


        <div class="con-form">
            <form autocomplete="off">
                <vs-select v-if="programa" class="aqui pt-0" id="programa" placeholder="Seleccionar programa" :key="programaId" v-model="programaSelect" :disabled="!programas.length">
                    <template>
                        <vs-option v-for="option in programas" :key="option.id"  :label="option.nombre" :value="option.id">
                            {{option.nombre}}
                        </vs-option>
                    </template>
                </vs-select>
            </form>
            <form autocomplete="off">
                <vs-select class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar cicloEscolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length">
                    <template>
                        <vs-option v-for="ciclo in ciclosEscolares" :key="ciclo.id"  :label="ciclo.text" :value="ciclo.id">
                            {{ciclo.text}}
                        </vs-option>
                    </template>
                </vs-select>
            </form>
        </div>

        <template #footer>
            <div class="con-footer" style="display: flex; justify-content: center;">
                <vs-button danger @click="borrar()">
                Cancelar
                </vs-button>
                <vs-button success @click="postProgramaNuevo()">
                Aceptar
                </vs-button>
            </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import landing from '../../../../../api/requests/landing'
    export default {
        props: [
            'value',
            'programa',
            'persona_id',
            'token'
        ],
        data:() => ({
            active: false,
            programaSelect: '',
            programas: [],
            programaId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            atributo: []
        }),
        methods:{
            async postProgramaNuevo(){
                console.log('programa nuevo')
            },
            async getAtributo(){
                if(this.programaSelect != ''){
                    const {data: response} = await landing.getAtributo(this.programaSelect)
                    this.atributo = response[0].id
                }
            },
            async getCiclosEscolares(){
                const {data: response} = await landing.getCiclosEscolares(this.programa.registros_academicos[0].institucion_id)
                this.ciclosEscolares = response
            },
            async postProgramaNuevo(){
                const loading = this.$vs.loading()
                try{
                    const formData  = new FormData();
                    formData.append('programa_id', this.programaSelect)
                    formData.append('ciclo_escolar_id', this.cicloEscolar)
                    formData.append('institucion_id', this.programa.registros_academicos[0].institucion_id)
                    formData.append('persona_id', this.persona_id)
                    formData.append('tipo_registro', 'reingreso')
                    formData.append('atributo_id', this.atributo)
                    formData.append('status_inscripcion', 'porautorizar')
                    const {data: response} = await landing.postReinscripcion(formData)
                    this.borrar()
                    loading.close()
                    this.$emit('refreshInfo')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Solicitud éxitosa',
                        text: 'Tu solicitud se ha enviado con éxito.'
                    })

                }catch{
                    loading.close()
                    this.active = false
                }
            },
            borrar(){
                this.active = false
                this.programaSelect = ''
            }
        },
        watch: {
            value (val) {
                this.active = val
            },    
            async active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
            programa(){
                this.programas = this.programa.registros_academicos[0].programas_disponibles
                this.getCiclosEscolares()
            },
            programaSelect(){
                this.getAtributo()
            }
        }
    }
</script>
